import { View } from "../../Core";
import { ModalHelper } from "../../Helpers/ModalHelper";
import Vue from "vue";
import { Uri } from "../../Core/Helpers/Uri";
import * as ajax from "@brightspark/sparkling-ajax-js";
import XelectComponent from "../../Components/Xelect/XelectComponent.vue";
import ValidationMessage from "../../Components/ValidationMessage/ValidationMessage.vue";

enum Action {
    Pay,
    SetAmount,
    GetEveryPayRequestData
}

class ViewDataModel {

    public cart: any;
    public groupMembers: any;
}

export class CartView extends View<CartView> {
    private _viewData: ViewDataModel = window.__VIEW_DATA;

    public constructor() {
        super();
        this.SetupVue(this);
    }

    SetupVue(view: CartView) {
        var modalHelper;
        const v = new Vue({
            el: ".app",
            data: {
                processing: false,
                cart: this._viewData.cart,
                groupMembers: this._viewData.groupMembers,
                model: {
                    acceptTerms: false,
                    selectedGroupMemberId: ""
                },
                validationResults: {},
                paymentError: ""
            },
            beforeMount() {
                modalHelper = new ModalHelper(this);
            },
            mounted() {
                
            },
            components: {
                XelectComponent,
                ValidationMessage
            },

            computed: {
                itemsCount() {

                    var count = 0;
                    for (var i = 0; i < this.cart.items.length; i++) {
                        count += this.cart.items[i].amount;
                    }   
                    return count;
                }
            },
            methods: {
                increaseAmount(cartItemId) {
                    var item = this.cart.items.find(x => x.id == cartItemId);
                    if (item) {
                        var amount = item.amount + 1;
                        view._setAmount(cartItemId, amount)
                            .done((res: any) => {
                                if (!res.isSuccess) {
                                    if (res.validationResults && res.validationResults.Size) {
                                        modalHelper.getNotificationModal(res.validationResults.Size.errors[0].error);
                                    }

                                    return;
                                }

                                res.item.cartItem.defaultImageThumbnailUrl = item.defaultImageThumbnailUrl;
                                Object.assign(item, res.item.cartItem);
                                this.updateSum(res.item);
                            });
                    }
                },
                decreaseAmount(cartItemId) {

                    var item = this.cart.items.find(x => x.id == cartItemId);
                    if (item) {
                        var amount = item.amount - 1;
                        if (amount <= 0) {
                            this.removeFromCart(cartItemId);
                            return;
                        }

                        view._setAmount(cartItemId, amount)
                            .done((res: any) => {
                                if (!res.isSuccess) {
                                    //v.validationResults = res.validationResults;
                                    return;
                                }

                                res.item.cartItem.defaultImageThumbnailUrl = item.defaultImageThumbnailUrl;
                                Object.assign(item, res.item.cartItem);
                                this.updateSum(res.item);
                            });
                    }
                },
                removeFromCart(cartItemId) {
                    view._setAmount(cartItemId, 0)
                        .done((res: any) => {
                            if (!res.isSuccess) {
                                //v.validationResults = res.validationResults;
                                return;
                            }

                            this.cart.items = this.cart.items.filter(x => x.id != cartItemId);
                            this.updateSum(res.item);
                        });
                },

                updateSum(sum) {
                    this.cart.priceTotal = sum.priceTotal;
                    this.cart.priceTotalWoVat = sum.priceTotalWoVat;
                    this.cart.vat = sum.vat;
                },

                everyPay() {
                    ajax(Uri.getUri(Action[Action.GetEveryPayRequestData]),
                        {
                            contentType: "application/json",
                            dataType: "json",
                            method: "post",
                            data: {
                                groupMemberId: this.model.selectedGroupMemberId,
                                cartId: this.cart.id
                            }
                        })
                        .done(res => {
                            this.paymentError = "";
                            if (!res.isSuccess) {
                                this.paymentError = res.validationSummary;
                            } else {
                                const data = res.item;
                                document.location.href = data.payment_link;
                            }
                        })
                        .always(x => {
                            this.processing = false;
                        });
                }
            }
        });
    }

    private _setAmount(cartItemId, amount) {

        var data = {
            cartItemId: cartItemId,
            amount: amount
        };

        return ajax(Uri.getUri(Action[Action.SetAmount]), {
            contentType: "application/json",
            dataType: "json",
            method: "post",
            data: data
        });
    }

    private _formSubmit(options) {

        const form = document.createElement("form");
        form.method = options.method;
        form.action = options.url;
        if (options.target) {
            form.target = options.target;
        }

        if (options.data) {
            for (let key in options.data) {
                if (options.data.hasOwnProperty(key)) {
                    const hiddenField = document.createElement("input");
                    hiddenField.type = "hidden";
                    hiddenField.name = key;
                    hiddenField.value = options.data[key];

                    form.appendChild(hiddenField);
                }
            }
        }

        document.body.appendChild(form);
        form.submit();
        form.remove();
    }
}


// WEBPACK FOOTER //
// ./www/js/Pages/Shop/CartView.ts